import { useFormikContext } from 'formik';
import { pick, mergeRight } from 'ramda';
import * as React from 'react';
import { EFormStatus } from '../../constants';
var PROPS_TO_PICK = ['values', 'touched', 'errors', 'isValid', 'isValidating', 'isSubmitting', 'dirty', 'status', 'submitCount', 'handleSubmit', 'submitForm'];

/**
 * Хук оборачивает useFormikContext и отдает ряд оригинальных пропсов (см PROPS_TO_PICK)
 * Требуется, чтоб клиент не знал про formik и использовал наш хук.
 * */
export var useFormContext = function useFormContext() {
  var formikContext = useFormikContext();
  var submitFormRaw = formikContext.submitForm,
    setStatus = formikContext.setStatus;

  /**
   * Вызов метода submitForm не устанавливает статус EFormStatus.QuestionSubmitted.
   * Когда возникает необходимость использовать кнопку сабмита вне формы, то приходится вручную вызывать метод submitForm,
   * однако status при этом не меняется. Для того чтобы исправить это поведение - делаем обёртку над функцией submitForm.
   */
  var submitForm = React.useCallback(function () {
    setStatus(EFormStatus.QuestionSubmitted);
    return submitFormRaw();
  }, [submitFormRaw, setStatus]);
  var overriddenProperties = {
    submitForm: submitForm
  };
  return pick(PROPS_TO_PICK, mergeRight(formikContext, overriddenProperties));
};